import { Component, ElementRef, Input, QueryList, ViewChildren } from '@angular/core';

import { GsapService } from '../../animations/gsap.service';
import { Offer } from '../../data/models/collections/offer';

@Component({
  selector: 'placeme-offer-card',
  templateUrl: './offer-card.component.html',
  styleUrls: ['./offer-card.component.scss'],
})
export class OfferCardComponent {
  @Input() offer: Offer;
  @Input() order = 0;

  @ViewChildren('offerCardRef') set offerCardRef(offerCardRef: QueryList<ElementRef<HTMLElement>>) {
    const offerCard: HTMLElement[] = offerCardRef.map(e => e.nativeElement);
    if (offerCard.length) {
      offerCard.forEach((card: HTMLElement) => {
        const offerCardElements: NodeListOf<Element> = card?.querySelectorAll('.reveal');
        this.gsapService.set(offerCardElements, { opacity: 0, scale: 0.9, yPercent: 10 });
        this.gsapService.createScrollTrigger({
          trigger: card,
          start: '-=100 50%',
          onEnter: () =>
            this.gsapService.timeline().to(offerCardElements, {
              opacity: 1,
              scale: 1,
              duration: 0.3,
              yPercent: 0,
              stagger: 0.2,
              ease: this.gsapService.easeInOut(),
            }),
          once: true,
        });
      });
    }
  }

  constructor(private gsapService: GsapService) {}
}
